export default __webpack_public_path__ + "static/media/mouro-capital-logo.f3a9e4b6.png";